module.exports = __webpack_public_path__ + "static/img/c4.83ab1870.png";